import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextStyled = styled.div`
  font-family: CurrysSans;
  font-size: 18px;
  padding: 21px 10px 11px 20px;
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 22px 5px 5px 10px;
  }
`;

const WeHelpHeading = ({
  text
}) => (
  <TextStyled>{text}</TextStyled>
);

WeHelpHeading.propTypes = {
  text: PropTypes.string.isRequired
};

export default WeHelpHeading;
